import localApi from '../../services/localApi'
import type { UsageProfile } from '../UserApi'
import type { ClientType } from '../ClientsApi'

export type OnboardingStep = 'profile' | 'operation' | 'team'
export interface OnboardingProfile {
  name: string
  email: string
  photo: string
  phone: string
  occupation: string
}
export interface OnboardingState {
  step: OnboardingStep | null
  showWelcome: boolean
  hasTeam: boolean
  teamOnly: boolean
  accountId: string
  accountName: string
  planName: string | null
  usageProfile: UsageProfile | null
  defaultClientId: string | null
  completedAt: string | null
  profile: OnboardingProfile
}
export interface OnboardingOperation {
  usageProfile: UsageProfile
  clientId?: string
  client?: { clientName: string, clientType: ClientType, clientCnpj?: string, clientCpf?: string }
}
interface Response { success: boolean, data: OnboardingState }

export const onboardingApi = {
  async getState (): Promise<OnboardingState> {
    return (await localApi.get<Response>('/v1/onboarding', { timeout: 15000 })).data.data
  },
  async welcome (): Promise<OnboardingState> {
    return (await localApi.post<Response>('/v1/onboarding/welcome')).data.data
  },
  async saveProfile (profile: Omit<OnboardingProfile, 'email'>): Promise<OnboardingState> {
    return (await localApi.put<Response>('/v1/onboarding/profile', profile)).data.data
  },
  async saveOperation (operation: OnboardingOperation): Promise<OnboardingState> {
    return (await localApi.put<Response>('/v1/onboarding/operation', operation)).data.data
  },
  async completeTeam (): Promise<OnboardingState> {
    return (await localApi.post<Response>('/v1/onboarding/team/complete')).data.data
  }
}
